import { useContext } from "react"
import { ClubeBeneficiosContext } from "./ClubeBeneficiosContext"

export function useClubeBeneficiosContext() {
    return useContext(ClubeBeneficiosContext)
}
